import React, { useEffect, useState } from "react";
import "./Home_SectionSix.scss";
import { getByPrice } from "../../../services/home/home";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";

function Home_SectionSix() {
  const [byPrice, setByPrice] = useState([]);

  useEffect(() => {
    const fetchApi = async () => {
      const contentByPrice = await getByPrice();
      setByPrice(contentByPrice);
      //   console.log(contentByPrice);
    };
    fetchApi();
  }, []);

  return (
    <>
      <div className="home-sectionSix">
        <div className="container">
          <div className="home-sectionSix-wrapper">
            {byPrice.length > 0 && (
              <React.Fragment>
                <div className="box-head">Mua sắm theo giá</div>

                <Row gutter={[20, 20]} className="by-price">
                  {byPrice.map((item) => (
                    <Col
                      key={item.id}
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={12}
                      sm={12}
                      xs={24}
                    >
                      <Link to="/products" className="by-price-item">
                        <div className="inner-main">
                          <div className="title">{item.title}</div>
                        </div>
                      </Link>
                    </Col>
                  ))}
                </Row>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Home_SectionSix;
